import SettingsStore from "@cayo/shared/settings/SettingsStore";
import GridViewSettings from "@cayo/shared/settings/types/GridViewSettings";
import PropertiesPanelSettings from "@cayo/shared/settings/types/PropertiesPanelSettings";
import { UserSettings } from "@cayo/shared/settings/types/userSettings";
import ViewSettings from "@cayo/shared/settings/types/ViewSettings";

class AppSettings {
  public get userSetting(): SettingsStore<UserSettings, {}> {
    return this.userSettings;
  }

  public get panelSetting(): SettingsStore<PropertiesPanelSettings, {}> {
    return this.panelSettings;
  }

  public get viewSetting(): SettingsStore<ViewSettings, GridViewSettings> {
    return this.viewSettings;
  }

  private userSettings = new SettingsStore<UserSettings, {}>("user", localStorage);
  private panelSettings = new SettingsStore<PropertiesPanelSettings, {}>("panel", localStorage);
  private viewSettings = new SettingsStore<ViewSettings, GridViewSettings>("view", localStorage);
}

export const appSettings: AppSettings = new AppSettings();
